var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass:
        "layout-padding layout-padding--full-height flex justify-center items-center"
    },
    [
      _c(
        "div",
        { staticClass: "bg-white" },
        [
          _c("new-team-stepper", {
            ref: "newTeamStepper",
            on: { close: _vm.redirect }
          })
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }